import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../components/Auth/Login";
import Menu from "../components/Menu/Menu";
import Categories from "../components/Menu/Categories";
import Cart from "../components/Cart/Cart";
import Checkout from "../components/Checkout/Checkout";
import SubCategories from "../components/Menu/SubCategories";
import OrderPlaced from "../components/Checkout/OrderPlaced";
import LoginBridge from "../components/LoginBridge/LoginBridge";
import Profile from "../components/Profile/Profile";
import ProfileDetails from "../components/Profile/ProfileDetails";
import CardDetails from "../components/Profile/CardDetails";
import CheckoutGuest from "../components/Checkout/CheckoutGuest";
import Register from "../components/Register/Register";
import Logout from "../components/Logout";
import PreviousOrders from "../components/Orders/PreviousOrders";
import ViewPreviousOrder from "../components/Orders/ViewPreviousOrder";
import ForgotPassword from "../components/Auth/ForgotPassword";
import CustomerNumber from "../components/Profile/CustomerNumber";
import Splash from "../components/Auth/Splash";
import CheckoutWaiter from "@/components/Checkout/CheckoutWaiter";

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      redirect: {name: 'menu_categories'}
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/splash',
      name: 'splash',
      component: Splash
    },
    {
      path: '/menu-categories',
      name: 'menu_categories',
      component: Categories
    },
    {
      path: '/sub-categories/:category_id',
      name: 'menu_sub-categories',
      component: SubCategories
    },
    {
      path: '/menu/:category_id/:sub_cat_id',
      name: 'menu',
      component: Menu
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart
    },
    {
      path: '/cart/checkout',
      name: 'checkout',
      component: Checkout
    },
    {
      path: '/cart/checkout/guest',
      name: 'checkoutGuest',
      component: CheckoutGuest
    },
    {
      path: '/cart/checkout/waiter',
      name: 'checkoutWaiter',
      component: CheckoutWaiter
    },

    {
      path: '/checkout/order/:order_no',
      name: 'order',
      component: OrderPlaced
    },
    {
      path: '/checkout/bridge',
      name: 'loginBridge',
      component: LoginBridge
    },

    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      children: [
        {
          path: '/',
          component: ProfileDetails,
          name: 'profileDetails'
        },
        {
          path: 'card',
          component: CardDetails,
          name: 'cardDetails'
        },
      ]
    },

    {
      path: '/customer-no',
      name: 'customer-no',
      component: CustomerNumber
    },

    {
      path: '/register',
      name: 'register',
      component: Register
    },

    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },

    {
      path: '/previous-orders',
      name: 'previousOrders',
      component: PreviousOrders
    },

    {
      path: '/previous-orders/:order_no',
      name: 'viewPreviousOrder',
      component: ViewPreviousOrder
    },

    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: ForgotPassword
    },
]

const router = new VueRouter({
  routes
})

export default router
